export const BASE_URL = 'http://api.vmc.rs';
// http://api.vmc.rs
//localhost:8000
export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
